<template>
  <v-data-table :headers="displayHeaders" :items="items" :rows-per-page-items="[10]" hide-actions>
    <template slot="items" slot-scope="props">
      <td
        :class="{'text-xs-right':header.align==='right'}"
        :key="header.col"
        v-for="header in displayHeaders"
      >
        <span
          v-if="header.value === 'chargeItemScreenStatistics'"
        >{{ props.item.chargeItemScreenStatistics }}</span>
        <span
          v-if="header.value === 'subTotal'"
        >{{(shipment.paidType==='無償' && props.item.isValueCharge)?0:props.item.subTotal|currency}}</span>
        <span v-if="header.value === 'currencyCode'">{{props.item.currencyCode}}</span>
        <span
          v-if="header.value === 'consumptionTaxCode'"
        >{{props.item.consumptionTaxRate>0?'課税':'免税'}}</span>
        <span v-if="header.value === 'currencyRate'">{{ props.item.currencyRate }}</span>
        <span v-if="header.value === 'supplierName'">{{ props.item.supplierName }}</span>
        <span v-if="header.value === 'jpyTaxTotalNoTax'">{{ props.item.jpySubTotal|currency }}</span>
        <span v-if="header.value === 'jpyTotal'">{{ props.item.jpyTotal|currency }}</span>
        <span
          v-if="header.value === 'jpySubTotal'"
        >{{ (shipment.paidType==='無償' && props.item.isValueCharge)?0:props.item.jpySubTotal|currency({fractionCount:0}) }}</span>
        <span v-if="header.value === 'jpyTaxTotal'">{{ props.item.jpyTaxTotal|currency }}</span>
        <span v-if="header.value === 'comment'">{{props.item.comment}}</span>
        <span v-if="header.value === 'status'">{{ props.item.showStatus }}</span>

        <span
          v-if="header.value === 'showPaymentSubTotal'"
        >{{props.item.showPaymentSubTotal|currency}}</span>
        <span
          v-if="header.value === 'showPaymentJpySubTotal'"
        >{{props.item.showPaymentJpySubTotal|currency({fractionCount:0}) }}</span>
        <span
          v-if="header.value === 'showPaymentJpySubTotalNoTax'"
        >{{props.item.showPaymentJpySubTotal|currency }}</span>
        <span
          v-if="header.value === 'showPaymentJpyTaxTotal'"
        >{{props.item.showPaymentJpyTaxTotal|currency }}</span>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    shipment: Object,
    supplierId: String,
    columns: String,
    ignoreSupplier: { type: Boolean, default: false }
  },
  data() {
    return {
      headers: [
        {
          text: '費用項目',
          value: 'chargeItemScreenStatistics',
          sortable: false,
          col: '0'
        },
        {
          text: '金額',
          value: 'subTotal',
          sortable: false,
          align: 'right',
          col: '1'
        },
        { text: '通貨', value: 'currencyCode', sortable: false, col: '2' },
        {
          text: '税区分',
          value: 'consumptionTaxCode',
          sortable: false,
          col: '3'
        },
        {
          text: 'レート',
          value: 'currencyRate',
          sortable: false,
          align: 'right',
          col: '4'
        },
        { text: '支払先', value: 'supplierId', sortable: false, col: '5' },
        {
          text: '円換算税抜金額',
          value: 'jpyTaxTotalNoTax',
          sortable: false,
          align: 'right',
          col: '6'
        },
        {
          text: '円換算税金金額',
          value: 'jpyTaxTotal',
          sortable: false,
          align: 'right',
          col: '7'
        },
        { text: 'コメント', value: 'comment', sortable: false, col: '8' },
        { text: 'ステータス', value: 'status', sortable: false, col: '9' },
        {
          text: '換算金額',
          value: 'jpySubTotal',
          sortable: false,
          align: 'right',
          col: '10'
        },
        {
          text: '金額',
          value: 'showPaymentSubTotal',
          sortable: false,
          align: 'right',
          col: '11'
        },
        {
          text: '換算金額',
          value: 'showPaymentJpySubTotal',
          sortable: false,
          align: 'right',
          col: '12'
        },
        {
          text: '円換算税抜金額',
          value: 'showPaymentJpySubTotalNoTax',
          sortable: false,
          align: 'right',
          col: '13'
        },
        {
          text: '円換算税金金額',
          value: 'showPaymentJpyTaxTotal',
          sortable: false,
          align: 'right',
          col: '14'
        }
      ]
    }
  },
  computed: {
    items() {
      if (this.ignoreSupplier) {
        return this.shipment && this.shipment.summaryCharges
      } else {
        return (
          this.shipment &&
          this.shipment.summaryCharges &&
          this.shipment.summaryCharges.filter(
            s => s.supplierId === this.supplierId
          )
        )
      }
    },
    displayHeaders() {
      if (this.columns) {
        return this.columns
          .split(',')
          .map(c => this.headers.find(h => h.col === c))
      } else {
        return this.headers
      }
    }
  }
}
</script>